<template>
  <appQuoteNew
    :propsMode="'new'"
    :quoteType="'leads'"
    :leadSource="'RVL'"
  ></appQuoteNew>
</template>
<script>
import appQuoteNew from '../../../components/quote/quoteNew.vue'
export default {
  name: 'LeadsNew',
  components: {
    appQuoteNew
  }
}
</script>
